import React from 'react';
import { MenuItem, SelectField, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TextField } from 'material-ui';

import { sanctionsLists, sanctionsPrograms } from 'constants/sancitons';

export default function Sanctions({ sanctions, changeFieldsMultiple }) {
    return (
        <div>
            <Table
                selectable={false}
            >
                <TableHeader
                    adjustForCheckbox={false}
                    displaySelectAll={false}
                >
                    <TableRow>
                        <TableHeaderColumn style={{ width: '18.5%' }}>
                            {null}
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '16.5%' }}>
                            Status
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '16.5%' }}>
                            List
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '16.5%' }}>
                            Program
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            Remarks
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody
                    displayRowCheckbox={false}
                >
                    <TableRow
                        displayBorder
                    >
                        <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '18.5%', padding: 10 }} >Sanctions</TableRowColumn>
                        <TableRowColumn style={{ border: '1px solid #dfdfdf', padding: 0, width: '16.5%' }}>
                            <Table allRowsSelected={false}>
                                <TableBody displayRowCheckbox={false}>
                                    <TableRow selectable={false} displayBorder><TableRowColumn style={{ padding: '0 5px' }} >OFAC</TableRowColumn></TableRow>
                                    <TableRow selectable={false} displayBorder><TableRowColumn style={{ padding: '0 5px' }}>Other Sanctions</TableRowColumn></TableRow>
                                </TableBody>
                            </Table>
                        </TableRowColumn>
                        <TableRowColumn style={{ border: '1px solid #dfdfdf', padding: 0, width: '16.5%' }}>
                            <Table allRowsSelected={false}>
                                <TableBody displayRowCheckbox={false}>
                                    <TableRow selectable={false} displayBorder>
                                        <TableRowColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[0] && generateSelectors({
                                                    value: sanctions[0].list, 
                                                    sanctionsList: sanctionsLists, 
                                                    field: 'sanctions[0].list',
                                                    multiple: false, 
                                                    changeField: changeFieldsMultiple, 
                                                    checked: false,
                                                })
                                            }
                                        </TableRowColumn>
                                    </TableRow>
                                    <TableRow selectable={false} displayBorder>
                                        <TableRowColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[1] && generateTextFields({
                                                    value: sanctions[1].list,
                                                    field: 'sanctions[1].list',
                                                    changeField: changeFieldsMultiple,
                                                })
                                            }
                                        </TableRowColumn>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableRowColumn>
                        <TableRowColumn style={{ border: '1px solid #dfdfdf', padding: 0, width: '16.5%' }}>
                            <Table allRowsSelected={false}>
                                <TableBody displayRowCheckbox={false}>
                                    <TableRow selectable={false} displayBorder>
                                        <TableRowColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[0] && generateSelectors({
                                                    value: sanctions[0].programs || sanctions[0].program, 
                                                    sanctionsList: sanctionsPrograms, 
                                                    field: 'sanctions[0].programs',
                                                    multiple: true, 
                                                    changeField: changeFieldsMultiple, 
                                                    checked: true,
                                                })
                                            }
                                        </TableRowColumn>
                                    </TableRow>
                                    <TableRow selectable={false} displayBorder>
                                        <TableRowColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[1] && generateTextFields({
                                                    value: sanctions[1].programs || sanctions[1].program,
                                                    field: 'sanctions[1].programs',
                                                    changeField: changeFieldsMultiple,
                                                    asArray: true,
                                                })
                                            }
                                        </TableRowColumn>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableRowColumn>
                        <TableRowColumn style={{ border: '1px solid #dfdfdf', padding: 0 }}>
                            <Table allRowsSelected={false}>
                                <TableBody displayRowCheckbox={false}>
                                    <TableRow selectable={false} displayBorder>
                                        <TableHeaderColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[0] && generateTextFields({
                                                    value: sanctions[0].remarks,
                                                    field: 'sanctions[0].remarks',
                                                    changeField: changeFieldsMultiple,
                                                })
                                            }
                                        </TableHeaderColumn>
                                    </TableRow>
                                    <TableRow selectable={false} displayBorder>
                                        <TableHeaderColumn style={{ padding: '0 5px' }}>
                                            {
                                                sanctions[1] && generateTextFields({
                                                    value: sanctions[1].remarks,
                                                    field: 'sanctions[1].remarks',
                                                    changeField: changeFieldsMultiple,
                                                })
                                            }
                                        </TableHeaderColumn>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableRowColumn>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
}

function generateSelectors({ value, sanctionsList, field, multiple, changeField, checked }) {
    return (
        <SelectField
            multiple={multiple}
            autoWidth
            value={(value) || []}
            style={{ width: '100%', fontSize: '13px' }}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            labelStyle={{ height: '45px', padding: 0 }}
            onChange={(_e, _i, _value) => {
                const toChange = [{
                    field,
                    value: _value,
                }];
                if (field === 'program') {
                    toChange.push({
                        field: 'programs',
                        value: _value,
                    });
                }
                changeField(toChange);
            }}
        >
            {
                sanctionsList.map((program) => {
                    return (
                        <MenuItem 
                            key={program}
                            checked={checked && value && value.includes(program)}
                            value={program}
                            primaryText={program}
                        />
                    );
                })
            }
        </SelectField>
    );
}

function generateTextFields({ value, field, changeField, asArray = false }) {
    return (
        <TextField 
            name={field}
            value={value}
            onChange={(e) => {
                const toChange = [{
                    field,
                    value: asArray ? [e.target.value] : e.target.value,
                }];

                if (field.includes('programs')) {
                    toChange.push({
                        field: `${field.split('.')[0]}.program`,
                        value: [e.target.value]
                    });
                }

                changeField(toChange);
            }}
            style={{ width: '100%', fontSize: '13px' }}
            underlineStyle={{ display: 'none' }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Sanctions.jsx